// Empty stub for Node built-ins (e.g. `stream`) in the browser build.
//
// xlsx-js-style declares `"stream": false` in its package.json `browser` field
// — it never touches `stream.Readable` in browser code paths. Vite externalizes
// the Node builtin anyway and logs the noisy "Module stream has been
// externalized … Cannot access stream.Readable in client code" warning.
// Aliasing `stream` to this empty module (see vite.config.ts resolve.alias)
// honors the package's declared intent and preserves the same empty runtime
// behavior, minus the warning.
export default {};
